import { Card, CardContent, Typography } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { authProvider } from '../../services/Security';
import { StatsService } from '../../services/StatsService';

const NumberOfActiveAccounts = () => {
    const [stats, setStats] = useState<any>();
    const [operatorId, setOperatorId] = useState<any>();
    // const [token, setToken] = useState<any>();

    useEffect(() => {
    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if(!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        setOperatorId(data?.operatorId)
        StatsService.statsVGetActiveAccountsCount(data?.operatorId, data?.districtId)
            .then(x => setStats(x))
            .catch(x => console.log(x))
        // setToken(data?.token)
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    }); 
    }, [])

    return (
        <Card raised={false} style={{width: "100%"}}>
            <CardContent>
                <Typography variant="h5" component="h2" style={{textAlign:"center"}}>Active Accounts</Typography>
                {operatorId ?
                    <>
                        <div>
                            Total Active: {stats?.totalActive}
                        </div>
                        <div>
                            Active Portal Users: {stats?.portalAccounts}
                        </div>
                        <div>
                            Paperless Accounts: {stats?.paperlessAccounts}
                        </div>
                    </> :
                    <div>No Operator Selected</div>
                }
            </CardContent>
        </Card>
    );
}

export default NumberOfActiveAccounts;
  